import type { ComponentType } from "react";

/**
 * Settings sections a solution adds while it's switched on (Settings › Events, Settings › Loops…).
 * Each solution's admin module registers its own here.
 */
export interface SolutionSettings {
  /** The solution's key; the section shows only where it's switched on. */
  solution: string;
  /** The section's address under /settings. */
  key: string;
  label: string;
  icon: ComponentType;
  need?: string;
  Component: ComponentType;
}

import { settings as events } from "./events";
import { settings as people } from "./people";
import { settings as partners } from "./partners";
import { settings as loops } from "./loops";
import { settings as recaps } from "./recaps";
import { settings as shop } from "./shop";
import { settings as media } from "./media";
import { settings as marketing } from "./marketing";
import { settings as website } from "./website";
import { settings as legal } from "./legal";
import { settings as sales } from "./sales";
import { settings as finance } from "./finance";
import { settings as analytics } from "./analytics";
import { settings as newsroom } from "./newsroom";
import { settings as social } from "./social";
import { settings as meetings } from "./meetings";
import { settings as giveaways } from "./giveaways";
import { settings as collaborations } from "./collaborations";

export const SOLUTION_SETTINGS: SolutionSettings[] = [...events, ...people, ...partners, ...loops, ...recaps, ...shop, ...media, ...marketing, ...website, ...legal, ...sales, ...finance, ...analytics, ...newsroom, ...social, ...meetings, ...giveaways, ...collaborations];
